var map = {
	"./Article": 2064,
	"./Article/": 2064,
	"./Article/index": 2064,
	"./Article/index.jsx": 2064,
	"./Article/styles.module.css": 50574,
	"./CarouselLayout": 47235,
	"./CarouselLayout/": 47235,
	"./CarouselLayout/index": 47235,
	"./CarouselLayout/index.jsx": 47235,
	"./CarouselLayout/styles.module.css": 33995,
	"./CustomLayout": 64205,
	"./CustomLayout/": 64205,
	"./CustomLayout/index": 64205,
	"./CustomLayout/index.jsx": 64205,
	"./CustomLayout/styles.module.css": 83646,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;